import $ from "cash-dom";
import getCssVarValue from "./function_get-css-var-value";
import { gsap } from "gsap";

export default (function () {
    var selector = "[data-lazy]";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_lazy-load.js initialized", "green");

        var viewportHeight = $(".height-100lvh").eq(0)[0]?.clientHeight || window.innerHeight;
        var viewportWidth = window.innerWidth;
        var duration = getCssVarValue("--duration-lg") / 1000;
        var observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        var $el = $(entry.target);
                        var data = {
                            sizes: $el.data("sizes") || $el.attr("sizes") || Math.round($el.width()) + "px",
                            srcset: $el.data("srcset") || $el.attr("srcset"),
                            src: $el.data("src") || $el.attr("src"),
                        };

                        if ($el.is("img")) {
                            $el.attr({
                                sizes: data.sizes,
                                srcset: data.srcset,
                                src: data.src,
                            }).removeAttr("data-sizes data-srcset data-src");
                            $el.on("load", function () {
                                $el.attr("data-lazy", "loaded");
                            });
                        }

                        if ($el.is("video") || $el.is("audio")) {
                            $el.attr({
                                src: data.src,
                                type: data.type,
                            }).removeAttr("data-src data-type");
                            $el[0].load();
                            $el.on("canplay", function () {
                                $el.attr("data-lazy", "loaded");
                            });
                        }

                        if ($el.is("lottie-player")) {
                            if (!window.LottiePlayer) return;
                            $el.attr("src", data.src).removeAttr("src");
                            $el[0].load(data.src);
                            $el.on("ready", function () {
                                $($el[0].shadowRoot).find("svg").attr("preserveAspectRatio", "xMidYMid slice");
                                $el.attr("data-lazy", "loaded");
                            });
                        }

                        gsap.from($el[0], {
                            opacity: 0,
                            duration: duration,
                            onComplete: function () {
                                $el.css("opacity", null);
                            },
                        });

                        $el.trigger("lazyLoaded");
                        obs.unobserve($el[0]);
                    }
                });
            },
            {
                // rootMargin: `100px 0px`,
                rootMargin: `${viewportHeight * 2}px ${viewportWidth * 2}px`,
                threshold: 0.01,
            },
        );

        $(selector).each(function () {
            observer.observe($(this)[0]);
        });
    }

    $(document).ready(init);
})();
